import { DeliveryOrderStatus } from '@core/models/delivery/delivery-order-status';
import { OrderType } from '@core/models/delivery/order-type';
import { DateFilterRangeShortcut } from '@core/models/filter/date-filter-range-shorcut';
import { IListFilterState } from '@core/state/shared/list/list-filter-state';
import { FORMAT } from '@core/utils/formats';
import { MOMENT_UNIT } from '@core/utils/moment';
import * as moment from 'moment';

export interface ILiveViewOrdersFilterState extends IListFilterState {
    order_type?: OrderType;
    status?: DeliveryOrderStatus[];
    tracking_ids?: string[];
}

export const initialLiveViewOrdersFiltersState: ILiveViewOrdersFilterState = {
    locations: [],
    order_type: OrderType.DELIVERY,
    status: [],
    rangeShortcut: DateFilterRangeShortcut.CUSTOM,
    start: moment.utc().subtract(90, MOMENT_UNIT.MINUTES).format(FORMAT.DATETIME_SERVER),
    end: moment.utc().add(24, MOMENT_UNIT.HOURS).format(FORMAT.DATETIME_SERVER)
};
